import { isTelegramApp } from '@/utils/isTelegramApp';

import { useLaunchParams } from '@telegram-apps/sdk-react';

type LaunchParams = {
  platform?: string;
  [key: string]: any;
};

export function useAppLaunchParams(): LaunchParams {
  if (isTelegramApp()) return useLaunchParams();
  const params: Record<string, string> = {};

  const urlParams = new URLSearchParams(window.location.search);
  const inviteCode = urlParams.get('inviteCode');
  const startappCode = urlParams.get('startapp');

  if (inviteCode) params.invite_code = inviteCode;
  if (startappCode) params.invite_code = startappCode;

  urlParams.forEach((value, key) => {
    if (key.startsWith('utm_')) {
      params[key] = value;
    }
  });

  return params;
}
